import api from './api';

/**
 * FMD Biosecurity Intelligence API service.
 * Public endpoints (reports, risk-nearby, symptoms) work without auth;
 * dashboard endpoints require a logged-in user (token added by the api interceptor).
 */
export const fmdApi = {
  // ---- Public ----
  getReferenceData: async () => {
    const res = await api.get('/fmd/symptoms');
    return res.data;
  },

  submitReport: async (payload) => {
    // payload: { name, phone, lat, lng, species, herdSize, affectedCount, symptoms[], notes, address }
    const res = await api.post('/fmd/reports', payload);
    return res.data;
  },

  getRiskNearby: async (lat, lng) => {
    const res = await api.get('/fmd/risk-nearby', { params: { lat, lng } });
    return res.data;
  },

  // ---- Dashboard (protected) ----
  getStats: async () => {
    const res = await api.get('/fmd/stats');
    return res.data;
  },

  getCases: async (params = {}) => {
    const res = await api.get('/fmd/cases', { params });
    return res.data;
  },

  getCaseDetail: async (caseId) => {
    const res = await api.get(`/fmd/cases/${caseId}`);
    return res.data;
  },

  updateCaseStatus: async (caseId, status) => {
    const res = await api.patch(`/fmd/cases/${caseId}/status`, { status });
    return res.data;
  },

  getMapLayers: async (bbox) => {
    const res = await api.get('/fmd/map', { params: bbox || {} });
    return res.data;
  },

  getValidation: async (threshold = 50) => {
    const res = await api.get('/fmd/validation', { params: { threshold } });
    return res.data;
  },

  // Seed demo data (authenticated). Used by the dashboard "Load demo data" button.
  seedDemo: async () => {
    const res = await api.post('/fmd/seed-demo');
    return res.data;
  },
};

export default fmdApi;
